module.exports = __webpack_public_path__ + "static/the-amber-spyglass-his-dark-materials-3-1fb70fb598538ba923985575008309ea.jpg";